import React from 'react';
import ReactDOM from 'react-dom';
import Markit from './component/Markit';
import StockKChart from './component/StockKChart';
import StockKList from './component/StockKList';
import ColorBox from './component/ColorBox';
const style = {
  centerContainer: {
    overflow: "auto"
  }
}
ReactDOM.render(
  <section>
    <div style={style.centerContainer}>
      <ColorBox />
      <StockKList name='SP500 Sectors' symbolList={
        ['SPY',
          'XLK',
          'XLV',
          'XLY',
          'XLC',
          'XLF',
          'XLI',
          'XLP',
          'XLU',
          'XLB',
          'XLRE',
          'XLE']
      } />
      <StockKList name='GIANT' symbolList={
        ['AAPL', 'AMZN', 'TSLA', 'DIS', 'FB', 'MSFT', 'GOOG', 'NFLX', 'NVDA', 'BRK-B']} />
      <StockKList name='Market' symbolList={
        ['SPY', 'QQQ', 'ARKK', 'EEM', 'VGK', 'DX=F', '^TNX', 'GC=F', 'CL=F', 'HG=F', '000300.SS', 'BTC-USD', 'ETH-USD']
      } />
    </div>
  </section>
  ,
  document.getElementById('root')
);
